import React, { useState } from 'react'
import { Printer } from 'phosphor-react'

import { ComboboxReports } from '@/components/Combobox/Reports'
import DynamicReportRender from './dynamicReportRender'
import { Page } from '@/components/_layout/Page'
import { Button } from '@/components'
import { Controls } from './styles'

export default function QueriesPage() {
  const [selectedReport, setSelectedReport] = useState({
    reportId: null,
    reportName: '',
  })

  const handleReportSelect = (report) => {
    setSelectedReport(report)
  }

  const handlePrint = () => {
    window.print()
  }

  return (
    <>
      <Page.Container variant="transparent">
        <Page.Header title={selectedReport.reportName || 'Consultas'}>
          <Controls>
            <ComboboxReports
              getOptionSelected={(option, selectedOption) => {
                return option.value === selectedOption?.value
              }}
              onChange={(_e, option) =>
                handleReportSelect({
                  reportId: option.value,
                  reportName: option.label,
                })
              }
            />

            {selectedReport.reportId && (
              <Button
                size="medium"
                variant="outlined"
                color="primary"
                startIcon={<Printer />}
                onClick={handlePrint}
              >
                Imprimir
              </Button>
            )}
          </Controls>
        </Page.Header>

        <DynamicReportRender reportId={selectedReport.reportId} />
      </Page.Container>
    </>
  )
}
